import React from "react";

// latex imports
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";

export const LatexQuestionDiv = ({ q }) => {
  const macros = { "\\f": "#1f(#2)" };
  const opnArr = ["_", "A", "B", "C", "D"];
  let {
    question,
    question_link,
    option1,
    option1_link,
    option2,
    option2_link,
    option3,
    option3_link,
    option4,
    option4_link,
    answer,
    answer_link,
  } = q;
  return (
    <>
      <div class="mb-4">
        {question && (
          <>
            <p class="text-xl text-gray-900 ml-2 block">
              <Latex macros={macros}>{question}</Latex>
            </p>
          </>
        )}
        {question_link ? <img src={question_link}></img> : null}
      </div>
      <div class="mb-4">
        <span className="font-medium text-lg">A. </span>
        {option1 && (
          <>
            <Latex macros={macros}>{option1}</Latex>
          </>
        )}
        {option1_link ? <img src={option1_link}></img> : null}
      </div>
      <div class="mb-4">
        <span className="font-medium text-lg">B. </span>
        {option2 && (
          <>
            <Latex macros={macros}>{option2}</Latex>
          </>
        )}
        {option2_link ? <img src={option2_link}></img> : null}
      </div>
      <div class="mb-4">
        <span className="font-medium text-lg">C. </span>
        {option3 && (
          <>
            <Latex macros={macros}>{option3}</Latex>
          </>
        )}
        {option3_link ? <img src={option3_link}></img> : null}
      </div>
      <div class="mb-4">
        <span className="font-medium text-lg">D. </span>
        {option4 && (
          <>
            <Latex macros={macros}>{option4}</Latex>
          </>
        )}
        {option4_link ? <img src={option4_link}></img> : null}
      </div>
      <div class="mb-4">
        {answer && (
          <>
            <p for="country-option-1" class="text-lg font-light ml-2 block">
              <span className="text-lg text-lime-700">
                Ans: <span className="font-medium mx-1 ">{opnArr[answer]}</span>
              </span>
            </p>
          </>
        )}
        {answer_link ? <img src={answer_link}></img> : null}
      </div>
    </>
  );
};
